module.exports = __webpack_public_path__ + "static/media/honeycombListDot.4955c929.svg";